// useKeyboardAwareInput.ts
import { useEffect } from 'react';

import useDetectKeyboardOpen from 'use-detect-keyboard-open';

const useKeyboardAwareInput = () => {
  const isKeyboardOpen = useDetectKeyboardOpen();

  useEffect(() => {
    const activeElement = document?.activeElement as
      | HTMLElement
      | null
      | undefined;

    if (isKeyboardOpen && activeElement && activeElement.tagName === 'INPUT') {
      setTimeout(() => {
        activeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 124);
    }
  }, [isKeyboardOpen]);

  return null;
};

export default useKeyboardAwareInput;
